export const ATTENDANCE_TYPE_ID = {
  CLOCK_IN: '4ed06c66-5dcd-4542-adad-68d1ddc23860',
  CLOCK_OUT: '2b422143-81c0-45f0-a02a-f324689c835e',
};
